module.exports = __webpack_public_path__ + "static/media/Cronometro.8de1ca20.png";